import ngAnnotate from '../ngAnnotate.macro';

const answeringRoutes = $routeProvider => {
  $routeProvider

    .when('/answering/brokerages', {
      template: '<bb-brokerages-list />',
    })
    // NOTE: this route has been deprecated under the removeAngularJsonFeature flag
    .when('/answering/queue', {
      template: '<bb-answering-queue-host />',
      reloadOnSearch: false,
    })
    // NOTE: this route is deprecated when orgAdminFeature flag is enabled
    .when('/answering/settings', {
      template: '<brokerage-settings />',
    })

    .when('/answering/brokerage-grouping', {
      template: '<brokerage-grouping />',
    });
};

ngAnnotate(answeringRoutes);

angular
  .module('bb.answering')
  .config(answeringRoutes)
  .controller('BrokerageListController');
